<template>
  <div class="relative">
    <input
      v-model="urlLocal"
      class="border-0 px-3 py-3 pr-14 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
    />
    <a
      :target="urlLocal ? '_blank' : '_self'"
      :href="urlLocal ? urlLocal : 'javascript:void(0)'"
      ><button
        type="button"
        class="flex items-center justify-center absolute w-12 h-full top-0 right-0 placeholder-blueGray-300 border-gray-150 border border-solid text-blueGray-600 bg-gray-50 rounded-r text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
      >
        <IconLink class="fill-lightGray" /></button
    ></a>
  </div>
</template>

<script>
import IconLink from "@/assets/icons/IconLink";

export default {
  components: {
    IconLink
  },
  props: {
    url: {
      type: String,
      required: true
    }
  },
  computed: {
    urlLocal: {
      get: function () {
        return this.url;
      },
      set: function (val) {
        this.$emit("update:url", val);
      }
    }
  },
  emits: ["update:url"]
};
</script>
